import axios from './index';
import { notification } from 'antd';

// request统一处理
const request = (url, params, type) => {
    const methods = {
        axiosGet: 'get',
        axiosPost: 'post',
        axiosGetblob: 'get',
        axiosPostForm: 'post',
        axiosPostFile: 'post',
        axiosPut: 'put',
        axiosDelete: 'delete',
        axiosPatch: 'pacth',
    };
    if (!methods[type]) {
        notification.error({
            message: 'axios请求方式不存在，请确认。',
        });
        return;
    }
    let config = {
        method: methods[type],
        url,
    };
    switch (type) {
        case 'axiosGet':
            config = {
                ...config,
                params,
            };
            break;
        case 'axiosGetblob':
            config = {
                ...config,
                params,
                responseType: 'blob',
            };
            break;
        case 'axiosPostForm':
            config = {
                ...config,
                data: params,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            };
            break;
        case 'axiosPostFile':
            config = {
                ...config,
                data: params,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            };
            break;
        default:
            config = {
                ...config,
                data: params,
            };
            break;
    }
    return new Promise((resolve, reject) => {
        axios(config)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

/* 统一封装get请求 */
export const axiosGet = (url, params) => {
    return request(url, params, 'axiosGet');
};
/* 统一封装get blob请求 */
export const axiosGetblob = (url, params) => {
    return request(url, params, 'axiosGetblob');
};
/* 统一封装post请求 */
export const axiosPost = (url, params) => {
    return request(url, params, 'axiosPost');
};
/* 统一封装post请求 form格式 */
export const axiosPostForm = (url, params) => {
    return request(url, params, 'axiosPostForm');
};
/* 统一封装post请求 form格式 上传文件 */
export const axiosPostFile = (url, params) => {
    return request(url, params, 'axiosPostFile');
};
/* 统一封装put请求 */
export const axiosPut = (url, params) => {
    return request(url, params, 'axiosPut');
};
/* 统一封装delete请求 */
export const axiosDelete = (url, params) => {
    return request(url, params, 'axiosDelete');
};
/* 统一封装patch请求 */
export const axiosPatch = (url, params) => {
    return request(url, params, 'axiosPatch');
};

const httpRequest = {
    axiosGet,
    axiosPost,
    axiosGetblob,
    axiosPostForm,
    axiosPostFile,
    axiosPut,
    axiosDelete,
    axiosPatch,
};
export default httpRequest;
